import { supabase } from './supabase.js'

const API_BASE = import.meta.env.VITE_API_URL || ''

let _studentView = false
export function setStudentView(v: boolean) { _studentView = v }

export class ApiError extends Error {
  status: number
  body: unknown

  constructor(status: number, body: unknown) {
    const message = ApiError.extractMessage(status, body)
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.body = body
  }

  private static extractMessage(status: number, body: unknown): string {
    if (typeof body !== 'object' || body === null) return `API error ${status}`
    const b = body as Record<string, unknown>
    if (Array.isArray(b.errors) && b.errors.length > 0) {
      const detail = (b.errors[0] as Record<string, unknown>).detail
      if (typeof detail === 'string') return detail
    }
    if ('message' in b && typeof b.message === 'string') return b.message
    return `API error ${status}`
  }
}

export async function apiFetch<T>(
  endpoint: string,
  options?: Omit<RequestInit, 'body'> & { body?: unknown },
): Promise<T> {
  const {
    data: { session },
  } = await supabase.auth.getSession()

  const headers: Record<string, string> = {
    ...(options?.headers as Record<string, string>),
  }

  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`
  }

  if (_studentView) {
    headers['X-Student-View'] = 'true'
  }

  let body: BodyInit | undefined
  if (options?.body !== undefined) {
    headers['Content-Type'] = 'application/json'
    body = JSON.stringify(options.body)
  }

  const res = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
    body,
  })

  if (!res.ok) {
    let errorBody: unknown
    try {
      errorBody = await res.json()
    } catch {
      errorBody = { message: res.statusText }
    }
    throw new ApiError(res.status, errorBody)
  }

  if (res.status === 204) {
    return undefined as T
  }

  return res.json() as Promise<T>
}
